<template>
  <div class="flex flex-col py-4 gap-2 px-5 lg:px-8">
    <CreatedBy :task="task" />
    <TranslatableEditableTextArea
      :key="task.description"
      :original="task.description"
      :translation="task.problem.translated_description"
      v-model:showOriginal="showOriginal.description"
      variant="title"
      :maxLength="200"
      :readonly="readonly || !canEdit"
      submitMode="both"
      class="font-medium text-style-2xl lg:text-style-3xl"
      @update="$emit('update', { description: $event })"
    />
    <TaskMedia :task="task" :readonly="readonly" />
  </div>
  <div class="flex flex-col px-3 lg:px-6 pb-6 lg:pb-4 gap-6 lg:gap-4">
    <TaskProperties
      :task="task"
      :canEdit="canEdit && !readonly"
      :canLogTime="canLogTime && !readonly"
      :canLogMaterial="canLogMaterial && !readonly"
      :readonly="readonly"
      @update="$emit('update', $event)"
      @logTime="$emit('logTime')"
      @showTimeLog="$emit('showTimeLog')"
      @logMaterial="$emit('logMaterial')"
      @showMaterialLog="$emit('showMaterialLog')"
    />
    <TaskChecklist v-if="task.checklist?.items" :task="task" />
    <AdditionalInfo
      :original="task.remarks"
      :translation="task.translated_remarks"
      v-model:showOriginal="showOriginal.remarks"
      :readonly="readonly || !canEdit"
      @update="$emit('update', { remarks: $event })"
    />
    <TaskTags
      :task="task"
      :readonly="isArchived || !canEdit"
      @update="$emit('update', $event)"
    />
  </div>
</template>

<script setup>
import { inject } from "vue";
import { Checklist as TaskChecklist } from "@/SharedComponents/Checklist";
import { CreatedBy } from "@/SharedComponents/CreatedBy";
import { TranslatableEditableTextArea } from "@/SharedComponents/Inputs";
import { AdditionalInfo } from "@/SharedComponents/Parts";
import {
  TaskMedia,
  TaskProperties,
  TaskTags,
} from "@/SharedComponents/Tasks/TaskDetailsParts";

defineEmits([
  "update",
  "logTime",
  "showTimeLog",
  "logMaterial",
  "showMaterialLog",
]);

defineProps({
  task: { type: Object, required: true },
  canEdit: { type: Boolean, default: false },
  canLogTime: { type: Boolean, default: false },
  canLogMaterial: { type: Boolean, default: false },
  isArchived: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
});

const showOriginal = inject("showOriginal");
</script>
